import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppConfig } from '@app/config/app.config';

@Component({
  selector: 'app-ag-grid-pagination',
  templateUrl: 'ag-grid-pagination.component.html',
  styleUrls: ['./ag-grid-pagination.component.scss'],
})
export class AgGridPaginationComponent implements OnChanges {
  public currentPage: number;
  public lastPage: number;

  public startPage: number;
  public endPage: number;

  public desktopPages: number[];
  public mobilePages: number[];
  public tabletPages: number[];

  public totalPages: number;
  public totalData: number;

  public page: number;

  private currentPagerSize: number;

  public isMobile: boolean = false;
  public isTablet: boolean = false;
  public isDesktop: boolean = false;

  @Input() receivedTotalPages;
  @Input() receivedTotalData;
  @Input() receivedCurrentPage;

  @Output() newPageSearch: EventEmitter<any> = new EventEmitter();

  constructor(private deviceService: DeviceDetectorService) {
    if (this.deviceService.isDesktop) {
      this.isDesktop = true;
    } else if (this.deviceService.isTablet) {
      this.isTablet = true;
    } else if (this.deviceService.isMobile) {
      this.isMobile = true;
    }
    if (this.receivedCurrentPage !== undefined) {
      this.currentPage = this.receivedCurrentPage;
    }
  }

  ngOnChanges(): void {
    this.totalPages = this.receivedTotalPages;
    this.totalData = this.receivedTotalData;

    if (this.receivedCurrentPage !== undefined) {
      this.currentPage = this.receivedCurrentPage;
    }

    if (this.totalPages !== undefined) {
      if (this.isDesktop) {
        this.currentPagerSize = AppConfig.settings.env.agGridPagination.desktopPagerSize;
        this.buildPager(this.currentPagerSize);
      } else if (this.isTablet) {
        this.currentPagerSize = AppConfig.settings.env.agGridPagination.tabletPagerSize;
        this.buildPager(this.currentPagerSize);
      } else if (this.isMobile) {
        this.currentPagerSize = AppConfig.settings.env.agGridPagination.mobilePagerSize;
        this.buildPager(this.currentPagerSize);
      }
    }
  }

  onBtnFirst() {
    this.setPage(1);
  }

  onBtnLast() {
    this.setPage(this.totalPages);
  }

  onBtnNext() {
    if (this.currentPage < this.totalPages) {
      this.setPage(this.currentPage + 1);
    } else {
      return;
    }
  }

  onBtnPrevious() {
    if (this.currentPage > 0) {
      this.setPage(this.currentPage - 1);
    }
    else {
      return;
    }
  }

  buildPager(pagerSize: number) {
    if (this.currentPage < 1) {
      this.currentPage = 1;
    } else if (this.currentPage > this.totalPages) {
      this.currentPage = this.totalPages;
    }

    if ((this.currentPagerSize % 2) === 0) {
      this.startEndPagePairFinder(pagerSize);
    } else {
      this.startEndPageOddFinder(pagerSize);
    }

    if (this.deviceService.isDesktop) {
      this.desktopPages = Array.from(Array((this.endPage + 1) - this.startPage).keys()).map((x) => this.startPage + x);
    }
    else if (this.deviceService.isTablet) {
      this.tabletPages = Array.from(Array((this.endPage + 1) - this.startPage).keys()).map((x) => this.startPage + x);
    }
    else if (this.deviceService.isMobile) {
      this.mobilePages = Array.from(Array((this.endPage + 1) - this.startPage).keys()).map((x) => this.startPage + x);
    }
  }

  startEndPageOddFinder(pagerSize: number) {

    let halfOfPagerSize = Math.floor(pagerSize / 2);

    if (this.totalPages <= pagerSize) {
      this.startPage = 1;
      this.endPage = this.totalPages;
    } else {
      if (this.currentPage <= (halfOfPagerSize)) {
        this.startPage = 1;
        this.endPage = pagerSize;
      } else if (this.currentPage + (halfOfPagerSize) >= this.totalPages) {
        this.startPage = this.totalPages - (pagerSize - 1);
        this.endPage = this.totalPages;
      } else {
        this.startPage = this.currentPage - halfOfPagerSize;
        this.endPage = this.currentPage + halfOfPagerSize;
      }
    }
  }

  startEndPagePairFinder(pagerSize: number) {

    let halfOfPagerSize = Math.floor(pagerSize / 2);

    if (this.totalPages <= pagerSize) {
      this.startPage = 1;
      this.endPage = this.totalPages;
    } else {
      if (this.currentPage <= (halfOfPagerSize + 1)) {
        this.startPage = 1;
        this.endPage = pagerSize;
      } else if (this.currentPage + (halfOfPagerSize - 1) >= this.totalPages) {
        this.startPage = this.totalPages - (pagerSize - 1);
        this.endPage = this.totalPages;
      } else {
        this.startPage = this.currentPage - halfOfPagerSize;
        this.endPage = this.currentPage + (halfOfPagerSize - 1);
      }
    }
  }

  setPage(page: number) {
    this.currentPage = page;
    this.buildPager(this.currentPagerSize);
    this.newPageSearch.emit(this.currentPage);
  }
}